import React, { ReactNode } from "react";

import { ListItemButton, ListItemButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { IgTypography } from "./IgTypography";

interface IgListItemButtonsProps extends ListItemButtonProps {
  label: string | ReactNode;
  igVariant?: "primary" | "success";
  direction?: "row" | "column";
  buttonFontWeight?: number;
}
export const IgListItemButton = ({
  label,
  igVariant,
  buttonFontWeight,
  direction,
  ...rest
}: IgListItemButtonsProps) => {
  const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    // transition: "0.2s",
    borderRadius: "4px",
    justifyContent: "center",
    border: `1px solid ${theme.igBorders.core.default}`,
    "&:hover, &:focus": {
      border: `1px solid ${
        igVariant === "success"
          ? theme.igBorders.success.hover
          : theme.igBorders.core.hover
      }`,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected": {
      backgroundColor:
        igVariant === "success" ? "transparent !important" : "#E9F0FB",
      border: `1px solid ${
        igVariant === "success"
          ? theme.igBorders.success.active
          : theme.igBorders.accent.active
      }`,
    },
  }));

  return (
    <StyledListItemButton {...rest}>
      <IgTypography sx={{ fontWeight: buttonFontWeight ?? 600 }}>
        {label}
      </IgTypography>
    </StyledListItemButton>
  );
};
